module.exports = [{"type":"quest","quest":"airport-train-station","stage":"found-ticket-booth","journal":"You notice a ticket machine in the train station.","filters":[{"type":"flag","flag":"discovered:airport-train-station-ticket-booth","value":false}],"effects":[{"type":"discover","location":"airport-train-station-ticket-booth"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/train-station.json
// module id = 202
// module chunks = 0